// React and related imports
import React from 'react';

// flowbite-react components
import { Pagination } from 'flowbite-react';

// i18n hook
import { t } from 'i18next';

interface CustomPaginationProps {
  currentPage: number;
  totalPages?: number;
  onPageChange: (page: number) => void;
}

export const CustomPagination: React.FC<CustomPaginationProps> = ({
  currentPage,
  onPageChange,
  totalPages = 10,
}) => {
  return totalPages > 1 ? (
    <div className="my-2 flex overflow-x-auto sm:justify-center">
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        previousLabel={t('contentContext.previous')}
        nextLabel={t('contentContext.next')}
        className={'pagination'}
      />
    </div>
  ) : null;
};
